import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {AddStoreForm} from "./AddStoreForm";
import {ShopifyLogo} from "../../logos/ShopifyLogo";
import { withTranslation } from 'react-i18next';

class AddStoreModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit(newShopifyStoreData) {
        this.toggle();
        this.props.afterSuccessfulSubmit(newShopifyStoreData);
    }

    render() {
        const { t } = this.props;
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop="static">
                <ModalHeader toggle={this.toggle}><ShopifyLogo/>&nbsp;{t('add_store_modal.connect_with_shopify')}</ModalHeader>
                <AddStoreForm afterSuccessfulSubmit={this.afterSuccessfulSubmit}
                                  clientId={this.props.clientId}
                                  clientName={this.props.clientName}/>
            </Modal>
        );
    }
}

export const AddStoreModal = withTranslation()(AddStoreModalClass);

